module.exports = __webpack_public_path__ + "static/media/heb.896ddae6.png";


//////////////////
// WEBPACK FOOTER
// ./src/new_components/generic/png/heb.png
// module id = 7360
// module chunks = 4